/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("variant:changed", function (event) {
  const productForm = event.target.closest(".product-form") || event.target;
  if (!productForm || !event.detail?.variant) return;

  const mpn = productForm.querySelector(".product-meta__mpn");
  const mpnNumber = productForm.querySelector(".product-meta__mpn-number");

  if (!mpn || !mpnNumber) return;

  const barcode = event.detail.variant.barcode || "";

  mpnNumber.textContent = barcode;
  mpn.style.display = barcode ? "" : "none";
});

function updateInventoryStatusColor(container, variantId) {
  const inventoryElement = container.querySelector(
    ".product-form__inventory"
  );

  const productJsonElement = container.querySelector(
    "[data-product-json]"
  );

  if (!inventoryElement || !productJsonElement) return;

  try {
    const productData = JSON.parse(productJsonElement.textContent);
    const inventory = productData.inventories[String(variantId)];

    const isOutOfStock =
      inventory &&
      inventory.inventory_management &&
      Number(inventory.inventory_quantity) <= 0;

    inventoryElement.classList.toggle(
      "inventory--out-of-stock",
      Boolean(isOutOfStock)
    );
    let shippingNote = container.querySelector(".dds-shipping-estimate");
    if (!shippingNote) {
      shippingNote = document.createElement("div");
      shippingNote.className = "dds-shipping-estimate";
      shippingNote.setAttribute("aria-live", "polite");
      shippingNote.innerHTML = `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
          style="flex-shrink:0; margin-top:2px;"
        >
          <path d="M1 3h14v13H1z"/>
          <path d="M15 8h4l3 4v4h-7"/>
          <path d="M15 12h7"/>
          <circle cx="5.5" cy="18" r="2.5"/>
          <circle cx="18.5" cy="18" r="2.5"/>
        </svg>
        <span class="dds-shipping-estimate__text"></span>
      `;
    }
    inventoryElement.insertAdjacentElement("afterend", shippingNote);
    // Match the stock indicator's current color and typography.
    const stockStyle = window.getComputedStyle(inventoryElement);
    Object.assign(shippingNote.style, {
      display: inventory ? "flex" : "none",
      alignItems: "flex-start",
      gap: "8px",
      flexBasis: "100%",
      marginTop: "6px",
      color: stockStyle.color,
      fontFamily: stockStyle.fontFamily,
      fontSize: stockStyle.fontSize,
      fontWeight: stockStyle.fontWeight,
      fontStyle: stockStyle.fontStyle,
      lineHeight: stockStyle.lineHeight,
      letterSpacing: stockStyle.letterSpacing
    });
    shippingNote.querySelector(".dds-shipping-estimate__text").textContent =
      isOutOfStock
        ? "Special order: This item must be ordered from the manufacturer. Ships in approximately 10–12 days."
        : "Ships in 1–2 days. Same-day shipping if ordered before 3 PM, Monday–Friday.";
    shippingNote.hidden = !inventory;

  } catch (error) {
    console.error("Unable to read inventory data:", error);
  }
}

document.addEventListener("variant:changed", function (event) {
  const container =
    event.target.closest(".shopify-section") || document;

  updateInventoryStatusColor(
    container,
    event.detail.variant.id
  );
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".shopify-section").forEach(function (container) {
    const productJsonElement = container.querySelector("[data-product-json]");

    if (!productJsonElement) return;

    try {
      const productData = JSON.parse(productJsonElement.textContent);

      updateInventoryStatusColor(
        container,
        productData.selected_variant_id
      );
    } catch (error) {
      console.error("Unable to initialize inventory color:", error);
    }
  });
});